/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { TextField } from "@mui/material";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import LabelledField from "components/labelled-field";
import { ComponentImageLinkEditWrapper } from "./component-image-link-wrapper";
import { ImageLinkItemEditor } from "./list-item";

const ImageLinkComponentEditor = () => {
    const { component, update, updateFactory } = useUpdateComponent();
    const sectionName = component?.sectionName;
    const imageList = component?.image_list;

    const onChangeSectionName = (event) => {
        const sectionName = event.target.value;
        update("sectionName", sectionName);
    };

    const onChangeImageList = updateFactory("image_list");
    return (
        <div className="simplicity-editor-frame image-link-editor">
            <div className="image-link-editor-section">
                <LabelledField label="Section Name">
                    <TextField
                        id="image_link_section_name"
                        fullWidth={true}
                        value={sectionName}
                        onChange={onChangeSectionName}
                    />
                </LabelledField>
            </div>
            <div className="image-link-editor-links">
                <ComponentImageLinkEditWrapper list={imageList} onChange={onChangeImageList}>
                    <ImageLinkItemEditor />
                </ComponentImageLinkEditWrapper>
            </div>
        </div>
    );
};
ImageLinkComponentEditor.displayName = "ImageLinkComponentEditor";
export { ImageLinkComponentEditor };
